<template>
    <div v-if="loading" class="loading">{{ trans("Aan het laden...") }}</div>
    <div v-else-if="item_id" class="tab" v-for="(tab, index) in componentData.workflowlayoutdetailtab">
        <!--<h3 class="h3" v-if="!this.workflowboard_id">{{ tab.label }}</h3>-->

        <fieldset v-if="workflowpropertiesbyfieldgroup(tab.property.id).length && fieldset_visible(tab.property.id, item_id)">
            <Fields
                :key="`detail_fields_${item_id}_${viewData.workflowboard_id}_${tab.property.id}`"
                :editing="false"
                :preview="true"
                :fields="workflowpropertiesbyfieldgroup(tab.property.id)"
                :values="workflowproperties(item_id)"
                module_object="Workflowpropertyfield"
            />
        </fieldset>
        <template v-for="fieldgroup in workflowpropertyfieldgroupsbyfieldgroupid(tab.property.id)">
            <fieldset v-if="workflowpropertiesbyfieldgroup(fieldgroup.id).length && fieldset_visible(fieldgroup.id, item_id)">
                <legend>{{ fieldgroup.title }}</legend>
                <Fields
                    :key="`detail_fields_${item_id}_${viewData.workflowboard_id}_${fieldgroup.id}`"
                    :editing="false"
                    :preview="true"
                    :fields="workflowpropertiesbyfieldgroup(fieldgroup.id)"
                    :values="workflowproperties(item_id)"
                    module_object="Workflowpropertyfield"
                />
            </fieldset>
        </template>
    </div>
    <template v-if="!loading">

        <Teleport :to="this.teleport_navbar || '.RemarkBar'" :disabled="!this.teleport_navbar">
            <nav v-if="!this.teleport_navbar">
                <button v-if="!viewData.config?.settings?.disabled?.chat" type="button" class="more outline" @click.prevent="handleMessageClick()">
                    <span class="title">{{ trans(text("Chat openen")) }}</span>
                </button>
                <button type="button" class="more" @click.prevent="handleMessageClick()">
                    <span class="title">{{ trans(text("Vraag stellen")) }}</span>
                </button>
            </nav>
            <template v-else>
                <button v-if="!viewData.config?.settings?.disabled?.chat" type="button" class="more outline" @click.prevent="handleMessageClick()">
                    <span class="title">{{ trans(text("Chat openen")) }}</span>
                </button>
                <button type="button" class="more" @click.prevent="handleMessageClick()">
                    <span class="title">{{ trans(text("Vraag stellen")) }}</span>
                </button>
            </template>
        </Teleport>
    </template>
</template>

<script>
import {defineComponent, onMounted, reactive, ref, computed, inject, watch } from "vue";
import {useStore} from "vuex";

// Helper functions

import { item, fetchItem} from "store/portal";
import { postDataAsync, getDataAsync } from "helpers/_api";
import { resolveData } from "helpers/_data";
import trans from "helpers/_translation";

import Fields from "components/fields";

// Config for API urls used in this vue template
import config from "config";
import {
    workflowproperties,
    workflowlayoutdetailtab,
    workflowpropertiesbyfieldgroup,
    workflowpropertyfieldgroupsbyfieldgroupid
} from "store/workflow";

import { storeWorkflowcardPopoverType } from "store/workflowcard-popover";

export default defineComponent({
    components: {
        Fields
    },
    props: {
        item_id: {
            type: String,
            required: false
        },
        module_object: {
            type: String,
            required: false
        },
        depth: {
            type: Number,
            default: 0
        },
        teleport_navbar: {
            type: String,
            default: "",
            required: false
        }
    },
    setup(props) {

        const loading = ref(true);
        const viewData = inject("viewData");
        const text = inject("text");
        // const generalData = inject("generalData");
        const componentData = reactive({
            "item": [],
            "workflowlayoutdetailtab": []
        });

        const module_object = props.module_object;
        const item_id = computed(() => {
            return props.item_id;
        });

        const initData = () => {
            loading.value = true;

            const loadingPromises = [];
            loadingPromises.push(new Promise(resolve => {
                console.log("fetching item", module_object.toLowerCase(), item_id.value);
                fetchItem(module_object.toLowerCase(), item_id.value).then(result => {
                    componentData.item = result;
                    resolve();
                });
            }));
            loadingPromises.push(new Promise(resolve => {
                let watcher;
                const result = workflowlayoutdetailtab(viewData.workflowboard_id ? viewData.workflowboard_id : undefined);
                watcher = watch(
                    () => result,
                    () => {
                        if (typeof result !== "object") return;
                        componentData.workflowlayoutdetailtab = result;
                        resolve();
                        watcher && watcher();
                    },
                    {
                        immediate: true
                    }
                );
            }));
            Promise.all(loadingPromises).then(() => {
                setTimeout(() => {
                    loading.value = false;
                }, 500);
            });
        };

        const properties = computed(() => {
            const properties = {};
           componentData.item.extra.workflowproperties.forEach(a => {
               if (!a.value) return;
               properties[a.field.id] = a;
           });
           return properties;
        });
        const format = (data) => {
            return computed(() => {
                const tmpData = JSON.parse(JSON.stringify(data));
                return tmpData.map(item => {
                    item.extra.colclass = "span12";
                    return item;
                });
            }).value;
        };
        const filter = (data) => {
            return computed(() => {
                return data.filter(item => item.id in properties.value);
            }).value;
        };

        onMounted(() => {
            watch(
                () => item_id.value,
                (val) => {
                    if (!val) return;
                    initData();
                },
                {
                    immediate: true
                }
            )
        });


        // Get the title of the current fieldgroup_id if the fielgroup already was stored.
        const resolveLegend = (fieldgroup_id) => {
            // return generalData.workflowpropertyfieldgroup.data[fieldgroup_id]?.title
        };
        // Filter out specific field property values
        const resolveProperty = (item, propertyfield_id) => {
            const property =  item.extra.workflowproperties.find(a => {
                return `${a.field.id}` === `${propertyfield_id}`;
            });

            if (property && (propertyfield_id in componentData.properties)) {
                property.value = componentData.properties[propertyfield_id].value;
            }
            return property;
        };

        const resolvePropertyType = (property) => {
            return property.field?.type.split("\\").pop();
        };

        // Get an array with the parent id and all his sub ids
        const resolveSubIds = (target, selector, id) => {
            let ids = [id];
            target.filter(item => item[selector] == id).map(({id}) => id).forEach(subid => {
                ids = [...ids, ...resolveSubIds(target, selector, subid)];
            });
            return ids;
        };
        const resolvePropertyfieldByName = (name) => {
            // return generalData.workflowpropertyfields.find(field => field.name === name);
        };


        const fieldset_visible = (fieldset_id, workflowcard_id) => {
            return computed(() => {
                if (viewData.config.settings?.fieldset?.[`${fieldset_id}`]?.hide_if_empty) {
                    const fields = workflowpropertiesbyfieldgroup(fieldset_id);
                    const values = workflowproperties(workflowcard_id);
                    return fields.some(field => values.value[`${field.id}`]?.value);
                }
                return true;
            }).value;
        };

        const handleMessageClick = () => {
            storeWorkflowcardPopoverType("comments");
        };

        return {
            trans,
            text,

            loading,
            item_id,

            viewData,
            // generalData,
            componentData,

            properties,
            format,
            filter,

            resolveLegend,
            resolveProperty,
            resolvePropertyType,
            resolveSubIds,
            resolvePropertyfieldByName,

            fieldset_visible,

            workflowproperties,
            workflowlayoutdetailtab,
            workflowpropertiesbyfieldgroup,
            workflowpropertyfieldgroupsbyfieldgroupid,

            handleMessageClick
        };
    },
});
</script>

<style>
</style>